var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import Plugin, { hooksDescriptor, Events, Util } from '../../plugin';

var ErrorPlugin = function (_Plugin) {
  _inherits(ErrorPlugin, _Plugin);

  function ErrorPlugin() {
    _classCallCheck(this, ErrorPlugin);

    return _possibleConstructorReturn(this, (ErrorPlugin.__proto__ || Object.getPrototypeOf(ErrorPlugin)).apply(this, arguments));
  }

  _createClass(ErrorPlugin, [{
    key: 'afterCreate',
    value: function afterCreate() {
      var _this2 = this;

      hooksDescriptor(this);

      this.clickHandler = this.hook('errorRetry', this.errorRetry, {
        pre: function pre(e) {
          e.preventDefault();
          e.stopPropagation();
        } });

      this.onError = this.hook('errorHandler', this.handleError);

      this.bind('.xgplayer-error-refresh', 'click', this.clickHandler);
      this.on(Events.CANPLAY, function () {
        _this2.handleCanPlay();
      });

      this.on(Events.ERROR, function (error) {
        _this2.onError(error);
      });
    }
  }, {
    key: 'errorRetry',
    value: function errorRetry() {
      this.player.retry();
    }
  }, {
    key: 'handleCanPlay',
    value: function handleCanPlay() {
      Util.removeClass(this.player.root, 'xgplayer-is-error');
    }
  }, {
    key: 'handleError',
    value: function handleError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var player = this.player;

      var errorNote = error && error.message ? error.message : player.error;
      this.find('.xgplayer-error-text').innerHTML = errorNote;
      this.find('.xgplayer-error-tips').innerHTML = this.i18n.REFRESH_TIPS + '<span class="xgplayer-error-refresh">' + this.i18n.REFRESH + '</span>';
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.unbind('.xgplayer-error-refresh', 'click', this.clickHandler);
    }
  }, {
    key: 'render',
    value: function render() {
      return '<xg-error class="xgplayer-error">\n      <div class="xgplayer-errornote">\n       <span class="xgplayer-error-text"></span>\n       <span class="xgplayer-error-tips"><em class="xgplayer-error-refresh"></em></span>\n      </div>\n    </xg-error>';
    }
  }], [{
    key: 'pluginName',
    get: function get() {
      return 'error';
    }
  }]);

  return ErrorPlugin;
}(Plugin);

export default ErrorPlugin;